/*** IMPORTS FROM imports-loader ***/
var define = false;

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object'
    && typeof arg.copy === 'function'
    && typeof arg.fill === 'function'
    && typeof arg.readUInt8 === 'function';
}



//////////////////
// WEBPACK FOOTER
// C:/Build/cc0baf4df369d6e0/~/util/support/isBufferBrowser.js
// module id = 700
// module chunks = 49